import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

export class BraintreeStore extends BaseStore {

    getInitialState () {
        return super.getInitialState().merge({
            clientToken: null,
            paymentProcessing: false,
        });
    }

    getClientToken () {
        return this.get('clientToken');
    }

    getPaymentProcessing () {
        return this.get('paymentProcessing');
    }

    handleToken ({ token }) {
        this.setState(this.state.set('clientToken', token));
    }

    getActionHandlers () {
        return {
            [ActionTypes.BRAINTREE_CLIENT_TOKEN_LOADED]: this.handleToken,
            [ActionTypes.LOGGED_OUT]: this.resetState
        };
    }
}

const instance = new BraintreeStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/BraintreeStore.js